import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';
import { idValidator } from '@/schemas/common/validators';

/**
 * GET /api/chats/find query schema
 * Query parameters for finding a chat between buyer and seller
 */
export const FindChatQuerySchema = z.object({
  listingId: idValidator,
  buyerId: idValidator,
  sellerId: idValidator,
});

export type FindChatQuery = z.infer<typeof FindChatQuerySchema>;

/**
 * GET /api/chats/find response schema
 * Returns chatId if found, null if no chat exists
 */
export const FindChatResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    chatId: z.string().nullable(),
  }),
  ErrorResponseSchema,
]);

export type FindChatResponse = z.infer<typeof FindChatResponseSchema>;
